import React from 'react';
import { AdminProvider } from './AdminContext';
import AdminHeader from './AdminHeader';
import AdminBottomNav from './AdminBottomNav';
import AdminNavSheet from './AdminNavSheet';
import AdminProfileSheet from './AdminProfileSheet';
import './AdminShell.css';

/**
 * The Admin / Super-Admin application shell — top bar + content, with a nav drawer and a profile
 * sheet (both Sheet-based, the same overlay primitive the student product uses). Replaces the old
 * left Sidebar + hamburger Navbar + BottomNav (components/Sidebar.js, Navbar.js, BottomNav.js,
 * Layout.js — removed). `role` keeps the old <Layout role="..."> call-site contract so every route
 * in App.js only needed its component name swapped.
 */
export default function AdminShell({ role, children }) {
  return (
    <AdminProvider role={role}>
      <div className="az-shell">
        <a className="z-skip-link" href="#az-main">Skip to content</a>
        <AdminHeader />
        <main id="az-main" className="az-shell-main" tabIndex={-1}>
          <div className="az-content">{children}</div>
        </main>
        <AdminBottomNav />
        <AdminNavSheet />
        <AdminProfileSheet />
      </div>
    </AdminProvider>
  );
}
